import { render } from "./NavContent.vue?vue&type=template&id=9be1a716&scoped=true&ts=true"
import script from "./NavContent.vue?vue&type=script&lang=ts"
export * from "./NavContent.vue?vue&type=script&lang=ts"

import "./NavContent.vue?vue&type=style&index=0&id=9be1a716&scoped=true&lang=css"

import exportComponent from "/home/runner/work/dashboard/dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9be1a716"]])

export default __exports__